import getResponseJson from '../../services/getresponsejson';

const service = serviceRoutes => {
  const markAsReviewed = (encounterId, comment) => {
    return fetch(serviceRoutes.reviewHold, {
      credentials: 'include',
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        encounterId,
        comment
      })
    })
    .then(getResponseJson)
    .then(responseJson => {
      return Promise.resolve(responseJson.result);
    });
  };

  return {
    markAsReviewed
  };
};

export default service;
